import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import FileUploadArea from "./common/FileUploadArea"; // tu componente de subida
import DocumentCard from "./common/DocumentCard"; // versión corregida
import { useFileUploadMP } from "../../../../hooks/useUploadFileMP";
import { useDocuments } from "../../../../hooks/useDocuments";
import { useToast } from "../../../../../../Hooks/UseToast";

// Datos que ya tenías
import { DownloadFiles } from "../../../../../../services/DownloadFiles";

export default function TechnicalSpecificationsTab() {
  const { equipo } = useLocation().state;
  const fileId = equipo.uuid_documentacion;

  const { uploadFile, isUploading, uploadProgress } = useFileUploadMP();
  const { removeDocument, getDocuments, documents, ViewFiles } = useDocuments(
    []
  );
  const { showToast, Toast } = useToast();

  // 🔹 Refetch de documentos
  const refetchEspecificacionesDocs = () =>
    getDocuments(fileId, "especificaciones");

  useEffect(() => {
    if (fileId) refetchEspecificacionesDocs();
  }, [fileId]);

  // 🔹 Subida de archivos
  const handleFileSelect = async (files) => {
    if (!fileId) {
      console.log("No hay ID de archivo");
      return;
    }

    try {
      const data = await uploadFile(files, "especificaciones", fileId);
      console.log("Archivo subido:", data);

      await refetchEspecificacionesDocs();
      showToast("Archivo cargado con éxito", "success");
    } catch (err) {
      showToast("Error al subir archivo", "error");
    }
  };

  // 🔹 Eliminar archivo
  const handleDocumentDelete = async (doc) => {
    await removeDocument(doc.id, doc.nombre);
    await refetchEspecificacionesDocs();
    showToast("Archivo eliminado", "info");
  };

  // 🔹 Ver archivo
  const handleDocumentView = (document) => {
    ViewFiles(document.id_archivo + "-" + document.nombre, document.extension);
  };

  // 🔹 Descargar archivo
  const handleDocumentDownload = (document) => {
    DownloadFiles(document.id_archivo + "-" + document.nombre);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="Especificaciones Técnicas"
            subheader="Archivos con especificaciones técnicas detalladas, datasheets y documentos de ingeniería"
          />
          <CardContent>
            {/* Subida de archivos */}
            <Box sx={{ mb: 4 }}>
              <FileUploadArea
                title="Cargar Especificaciones Técnicas"
                description="Soporta PDF, Excel, DWG, DXF y archivos CAD"
                acceptedTypes=".pdf,.xlsx,.xls,.dwg,.dxf"
                onFileSelect={handleFileSelect}
                isUploading={isUploading}
                uploadProgress={uploadProgress}
              />
            </Box>

            {/* Información lateral */}
            {/*   <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Tipos de Archivo Soportados
                    </Typography>
                    <List dense>
                      {supportedFileTypes.map((fileType, index) => (
                        <ListItem key={index}>
                          <ListItemText
                            primary={`${fileType.type} - ${fileType.description}`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Información Requerida
                    </Typography>
                    <List dense>
                      {requiredInfo.map((info, index) => (
                        <ListItem key={index}>
                          <ListItemText primary={info} />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
 */}
            {/* Toasts */}
            {Toast}

            {/* Documentos cargados */}
            <Typography variant="h6" gutterBottom>
              Especificaciones Cargadas
            </Typography>
            {documents?.map((spec) => (
              <DocumentCard
                key={spec.id}
                document={spec}
                onView={handleDocumentView}
                onDownload={handleDocumentDownload}
                onDelete={handleDocumentDelete}
                showCategory={false}
              />
            ))}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
